<template>
  <div>
    <div class="p-18-10">
      <span class="mr-24 color-333 fz-14">总计：{{tagInfo.totalcount}} （上架{{tagInfo.totalcount >0 ? tagInfo.totalcount-tagInfo.cancelcount: 0}}/下架{{tagInfo.cancelcount}}）</span>
      <span class="mr-24 color-333 fz-14">待分配：{{cpx_order.order_goods_count && cpx_order.order_goods_count.to_assign}}</span>
      <span class="mr-24 color-333 fz-14">待审核：{{cpx_order.order_goods_count && cpx_order.order_goods_count.to_check}}</span>
      <span class="mr-24 color-333 fz-14">审核通过：{{cpx_order.order_goods_count && cpx_order.order_goods_count.checked_yes}}</span>
      <span class="mr-24 color-333 fz-14">审核不通过：{{cpx_order.order_goods_count && cpx_order.order_goods_count.checked_no}}</span>
    </div>

    <div class="p-18-10">
      <el-form label-position="right" ref="cpx_related_products_form_data" label-width="110px" size='large'  :model="form_data" inline>
          <el-form-item label="电商平台" prop="platform">
            <el-select v-model="form_data.platform" clearable placeholder="请选择">
              <el-option v-for="item in platform_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品标题" prop="goods_name">
            <el-input clearable v-model.trim="form_data.goods_name"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="check_status">
            <el-select v-model="form_data.check_status" clearable placeholder="请选择">
              <el-option v-for="item in status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否需要寄样" prop="is_retrieve_sample">
            <el-select v-model="form_data.is_retrieve_sample" clearable placeholder="请选择">
              <el-option v-for="item in yangpin_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否有带货任务" prop="kol_band">
            <el-select v-model="form_data.kol_band" clearable placeholder="请选择">
              <el-option v-for="item in task_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item></el-form-item>
      </el-form>
      <el-form label-width="110px">
        <el-form-item>
          <el-button type="primary" @click="search" size='medium'>搜索</el-button>
          <el-button @click="resetForm('cpx_related_products_form_data')" size='medium'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="p-18-10">
      <el-table :data="list_data" :header-cell-style="{background: '#f9f9f9', color: '#333'}">
        <el-table-column label="基本信息" width="300">
          <template slot-scope="scope">
            <div class="flex">
              <img class="page-goods-img" :src="scope.row.goods_img" alt="商品图">
              <div>
                <el-alert type="error" title="'!含敏感词!'" class="h-20" :closable="false" v-if="scope.row.sensitive"></el-alert>
                <div class="page-pointer" @click="goGoodsinfo(scope.row.goods_link)" v-html="changeColor(scope.row.goods_name,scope.row.sensitive)"></div>
                <div>商城：
                  <span v-if="scope.row.platform == 'taobao'">淘宝</span>
                  <span v-if="scope.row.platform == 'tianmao'">天猫</span>
                  <span v-if="scope.row.platform == 'jingdong'">京东</span>
                  <span v-if="scope.row.platform == 'suning'">苏宁</span>
                  <span v-if="scope.row.platform == 'kaola'">考拉</span>
                  <span v-if="scope.row.platform == 'douyin'">抖音小店</span>
                  <span v-if="scope.row.platform == 'weipinhui'">唯品会</span>
                  <span v-if="scope.row.platform == 'wangyiyanxuan'">网易严选</span>
                </div>
                <div>店铺：{{scope.row.store_name}}</div>
                <div>品牌：{{scope.row.brand_name}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关联带货任务">
          <template slot-scope="scope">
            <div class="hover" v-for="(item,inx) in scope.row.cpx_kol_user" :key="inx+'na'" @click="goBringDetail(item)">
              ID{{item.kldlid}}-{{item.kol_user_name}}-
              <span v-if="item.check_status==0">进行中</span>
              <span v-if="item.check_status==1">合作成功</span>
              <span v-if="item.check_status==2">合作失败</span>
              <span v-if="item.check_status==3">待审核</span>
              <span v-if="item.check_status==4">待发货</span>
              <span v-if="item.check_status==5">待收货</span>
              <span v-if="item.check_status==6">待交付</span>
              <span v-if="item.check_status==7">交付待确认</span>
              <span v-if="item.check_status==8">已拒绝</span>
              <span v-if="item.check_status==9">逾期</span>
              <span v-if="item.check_status==10">已取消</span>
              <span v-if="item.check_status==11">待填写寄样信息</span>
              <span v-if="item.check_status==12">待效果回传</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <div v-if="scope.row.is_head_coop==2">
              <div v-if="scope.row.platform == 'douyin'">商品实际推广时间：</div>
              <div v-else>商品实际团长时间：</div>
              <div v-if="scope.row.reality_begin_time">{{scope.row.reality_begin_time.slice(0,10)}}至<br/></div>
              <div>{{scope.row.reality_end_time&&scope.row.reality_end_time.slice(0,10)}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div class="p-warning" v-if="scope.row.check_status==1">待审核</div>
            <div class="p-color-succ" v-if="scope.row.check_status==2">审核通过</div>
            <div class="p-color-danger" v-if="scope.row.check_status==3">审核不通过
              <el-tooltip placement="top">
                <div slot="content" class="w-500">{{scope.row.refuse_reason}}</div>
                <i class="p-color-danger el-icon-question"></i>
              </el-tooltip>
            </div>
            <div class="p-warning" v-if="scope.row.check_status==4">待分配</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 页码 -->
      <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
    </div>
  </div>
</template>
<script>
import pagePagination from "@/components/page_pagination.vue"
import utils from "@/utils/util.js";

export default {
  name: "cpx_related_products",
  components: {
    pagePagination
  },
  props: {
    cxorid: ""
  },
  data() {
    return {
      // user_info: {},
      cpx_order: {},
      list_data: [],
      isCxoridGoodsProject: false, //当前登录人是否是商单商品负责人
      tagInfo: {
        totalcount: 0,
        cancelcount: 0,
        kolbandcount: 0,
        tofullcoopinfocount: 0,
        tosendbackcount: 0
      },
      person_options:[],
      platform_options: [//电商平台
        {label: "淘宝", value: "taobao"},
        {label: "天猫", value: "tianmao"},
        {label: "京东", value: "jingdong"},
        {label: "苏宁", value:"suning"},
        {label: "考拉", value:"kaola"},
        {label: "抖音小店", value: "douyin"},
        {label: "唯品会", value: "weipinhui"},
        {label: "网易严选", value: "wangyiyanxuan"}
      ],
      yangpin_options: [
        {value:'1',label:'否'},
        {value:'2',label:'是'},
      ],
      status_options: [
        {value:'1',label:'待审核'},
        {value:'2',label:'审核通过'},
        {value:'3',label:'审核不通过'},
        {value:'4',label:'待分配'}
      ],
      task_options: [
        {value:'1',label:'是'},
        {value:'2',label:'否'},
      ],
      upper_options: [
        {value:'1',label:'上架'},
        {value:'2',label:'下架'},
      ],
      form_data: {
        check_status: '',
        kol_band: '',
        is_retrieve_sample: '',
        goods_name: "",
        check_sensitive: '',
        tofullcoop: '',
        tofullback: "",
      },
      pageData: {
        count: 0,
        page: 1,
        offset: 10
      },
      rules: {
        check_down_reason: [ { required: true, message: '请填写理由', trigger: 'blur' },{ required: true, message: '请填写理由', trigger: 'change' } ],
        name: [{ required: true, message: '请输入收货人姓名', trigger: 'blur' }, { max: 10, message: '长度不超过10个字符', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入收货人电话', trigger: 'blur' }, {required: true, pattern: /^1[23456789]\d{9}$/, message: '请输入正确手机号格式',trigger: 'blur'}],
        province: [{required: true, message: '请选择所属省区', trigger: 'blur' },],
        city: [{required: true, message: '请选择所属市区', trigger: 'blur' },],
        area: [{required: true, message: '请选择所属区域', trigger: 'blur' },],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' },],
        adid: [ { required: true, message: '请选择', trigger: 'blur' },{ required: true, message: '请选择', trigger: 'change' } ],
      },
      apiUrl: {
        getCpxGoodsList: "/home/getCpxGoodsList", // cpx商单商品列表
        getAdidList: "/home/getAdidList" // 获取运营后台用户
      }
    };
  },
  created() {
    this.getData(1);
    this.getAdidList();
  },
  mounted() {
    // this.user_info = utils.getAuth("user_info") || {};
  },
  methods: {
    //初始化数据
    getData(p) {
      let _this = this;
      let data = {
        ..._this.form_data,
        offset: _this.pageData.page,
        limit: _this.pageData.offset,
        cxorid: _this.cxorid
      };
      _this
        .$http({
          method: "POST",
          url: _this.apiUrl.getCpxGoodsList,
          data: data
        })
        .then(res => {
          if (res.code == 1 && res.data) {
            const {
              list,
              count,
              totalcount,
              tosendbackcount,
              cancelcount,
              kolbandcount,
              tofullcoopinfocount,
              cpx_order
            } = res.data || {};
            _this.list_data = list;
            _this.pageData.page = p;
            _this.pageData.count = count || 0;
            _this.tagInfo = {
              ..._this.tagInfo,
              totalcount,
              tosendbackcount,
              cancelcount,
              kolbandcount,
              tofullcoopinfocount
            };
            _this.cpx_order = cpx_order || {};
            // cpx_order && cpx_order.cpx_order_goods_charge.forEach(item=>{
            //   if(item.project_adid == _this.user_info.adid){
            //     _this.isCxoridGoodsProject = true
            //     return;
            //   }
            // })
          } else {
            _this.list_data = [];
            _this.page.offset = 1;
            _this.pageData.count = 0;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getData(1);
    },
    changeColor(resultsList, keywords) {
      //查找敏感词
      if (!keywords) {
        return resultsList;
      }
      resultsList = resultsList.split(",");
      keywords = keywords.split(",");
      keywords.map((keyitem, keyindex) => {
        resultsList.map((item, index) => {
          if (keyitem && keyitem.length > 0) {
            // 匹配关键字正则
            let replaceReg = new RegExp(keyitem, "g");
            // 高亮替换v-html值
            let replaceString =
              '<span  style="background:yellow">' + keyitem + "</span>";
            resultsList[index] = item.replace(replaceReg, replaceString);
          }
        });
      });
      return resultsList.join(",");
    },
    // 搜索
    search(){
      this.form_data.check_sensitive = ''
      this.form_data.tofullcoop = ''
      this.form_data.tofullback = ''
      this.getData(1)
    },
    // 获取运营后台用户(2,6，7，11,17人员)
    getAdidList() {
      this.$http({
        method: "GET",
        url: this.apiUrl.getAdidList,
        params: {
          limit: 1000,
          offset: 1,
          status: 1,
          anreid: "2,6,7,11,17"
        }
      }).then(res => {
        if (res.code == 1) {
          this.person_options = res.data || [];
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 带货任务详情
    goBringDetail(row){
      let obj = {
        kldlid: row.kldlid
      }
      utils.openWindow('loaddetail', obj);
    },
    //重置搜索项目
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form_data.check_sensitive = ''
      this.form_data.kol_band = ''
      this.form_data.tofullcoop = ''
      this.form_data.tofullback = ''
    },
    //商品页面
    goGoodsinfo(url) {
      window.open(url);
    }
  }
};
</script>

<style scoped>
.flex{
  display: flex;
}
.pointer{
  cursor: pointer;
}
.img{
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-right: 10px;
}
.mr-24{
  margin-right: 24px;
}
.h-20{
  height: 20px;
}
.w-500{
  max-width: 500px;
}
.hover{
  cursor: pointer;
}
.hover:hover{
  color: #6435E8;
}
.p-18-10{
  padding: 18px 10px;
}
.fz-14{
  font-size: 14px;
}
.color-333{
  color: #333;
}
.p-text-clamp{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>